import styles from './Modal.module.scss'
import { Dialog, Transition } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import cn from 'classnames'

function Modal({ className, isOpen, setIsOpen, children, ...props }) {
  return (
    <Transition
      appear
      show={isOpen}
    >
      <Dialog
        as="div"
        className={cn('relative z-[9999]', styles['root'])}
        onClose={() => setIsOpen(false)}
        {...props}
      >
        <Transition.Child
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed left-0 top-0 h-screen w-screen bg-black/25" />
        </Transition.Child>

        <div className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel
                className={cn(
                  'w-[95vw] max-h-[95vh] max-w-xl overflow-scroll rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all',
                  { [className]: className }
                )}
              >
                <button
                  type="button"
                  className="-mr-1 -mt-1 mb-2 ml-auto block rounded p-1 transition-colors hover:bg-yellow-base/50"
                  onClick={() => setIsOpen(false)}
                >
                  <XMarkIcon className="h-8 w-8" />
                </button>

                <div>{children}</div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}

export default Modal
